var $4e14f10055f74dbb$exports = {};
$4e14f10055f74dbb$exports = {
    "invalidSelection": (args, formatter)=>`A kijel\xf6lt ${formatter.plural(args.selectedCount, {
            one: `d\xe1tum nem \xe9rhet\u{151} el`,
            other: `d\xe1tumok nem \xe9rhet\u{151}ek el`
        })}.`
};


export {$4e14f10055f74dbb$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
